<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons v-if="routeName != 'profile_stripe_connect'" slot="end">
      <ion-button @click="skip">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="main_wrapper ion-padding ">
    <div v-if="stripeStatus == 0" class="page_title">Payment System (Stripe Connect)
    </div>
    <div v-if="stripeStatus == 1" class="page_title">Payment System
    </div>
    <div v-if="stripeStatus == 2" class="page_title">Payment System
    </div>

    <div v-if="stripeStatus == 0">
      <div class="form_text">
        <div class="text mt-3">
          Locumate integrates with <a target="_blank" href="https://www.stripe.com">Stripe</a> to deliver a seamless
          payment process for you. Invoices will be automatically
          generated and sent to the pharmacy for payment after timesheets are approved. <br> <br>

          Stripe will be used to collect payments and distribute funds directly to you. You will receive a copy of the
          invoice for your records. Your Stripe Account will keep a history of all transactions. <br> <br>

          As Stripe is a secure payment gateway, some of your details will need to be verified. It only takes a few
          minutes, and you will no longer need to worry about creating your own invoices or managing payments manually.
          This will be done automatically for you. <br> <br>

        </div>
        <div class="text mt-3">It only takes a few minutes to connect your account.</div>
      </div>
      <div class="button-center mt-3">
        <button @click="createConnect" class="el-button el-button--blue ">
          Connect to Stripe
        </button>
      </div>
    </div>
    <div v-else-if="stripeStatus == 1">
      <div class="form_text">
        <div class="text mt-3">
          Locumate integrates with <a target="_blank" href="https://www.stripe.com">Stripe</a> to deliver a seamless
          payment process for Locums. Invoices will be automatically
          generated and sent to the pharmacy for payment after timesheets are approved. Stripe will be used to collect
          payments and distribute directly to Locums. You will receive a copy of the invoice for your records. Your
          Stripe
          Account will keep a history of all transactions.
        </div>
      </div>
      <div class="form_text">
        <h4 class="mt-3">
          <b> You account was already connected.</b>
        </h4>
      </div>
      <button @click="goToStripe" class="el-button el-button--blue ">
        Login to Stripe
      </button>
    </div>
    <div v-else-if="stripeStatus == 2">
      <div class="form_text">
        <div class="text mt-3">
          Something went wrong while creating your Stripe account. Please follow
          the link and make sure that all data is filled in correctly
        </div>
        <div class="text mt-3">It only takes a few minutes to connect your account.</div>
      </div>
      <div class="button-center mt-3">
        <button @click="refresh" class="el-button el-button--blue ">
          Continue onboarding
        </button>
      </div>
    </div>
    <div v-if="onboardingLink">
      <a :href="onboardingLink" class="el-button el-button--blue " style="display: none" id="js-onboarding-link" ref="hiddenLinkElement">Go to Stripe</a>
    </div>
    <div class="page_title">Security Information:
    </div>
    <div class="form_text">
      <div class="text mt-3">
        Stripe has been audited by a PCI-certified auditor and is certified to
        <a target="_blank"
           href="https://www.visa.com/splisting/searchGrsp.do?companyNameCriteria=stripe">PCI
          Service Provider Level
          1</a>.
        <br>
        This is the
        most stringent level of certification available in the payments industry.
        Stripes Privacy Policy can be accessed at:
        <a target="_blank"
           href="https://stripe.com/au/privacy">https://stripe.com/au/privacy</a>

      </div>
    </div>

  </div>
</template>

<script>
import {onMounted, inject, ref, watch} from "vue";
import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {IonToolbar, IonButton, IonButtons, IonIcon} from "@ionic/vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
  },

  setup() {
    let onboardingLink = ref(null);
    let hiddenLinkElement = ref(null);

    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const routeName = $route.name;
    const userData = $store.getters.GET_USER_DATA;

    watch(onboardingLink, function () {
      setTimeout(function () {
        hiddenLinkElement.value.click();
      }, 1);
    });

    const goBack = () => {
      if (routeName === "profile_stripe_connect") {
        $router.push({
          name: "profile",
        });
      } else {
        $router.push({
          name: $store.getters.getAuthPageBack,
        });
      }
    };

    const goNext = () => {
      console.log("next");
    };
    const stripeStatus = userData.stripeAccountStatus;

    const skip = () => {
      if (routeName != "profile_stripe_connect") {
        $store.dispatch("SAVE_USER_DATA", {
          survey: 1,
          hideLoading: true,
        });
      }
      $router.push({
        name: "intro",
      });
    };

    onMounted(() => {
      console.log("userData.stripeAccountStatus", userData.stripeAccountStatus);
      setPageClassGlobal("global_auth_page");
    });

    const createConnect = async () => {
      if (routeName != "profile_stripe_connect") {
        $store.dispatch("SAVE_USER_DATA", {
          survey: 1,
          hideLoading: true,
        });
      }
      await $store.dispatch("GET_STRIPE_CONNECT");

      onboardingLink.value = $store.getters.stripeConnectLink.link;
    };

    const refresh = async () => {
      await $store.dispatch("GET_STRIPE_REFRESH");

      onboardingLink.value = $store.getters.stripeRefreshLink;
    };
    const goToStripe = async () => {
      await $store.dispatch("GET_STRIPE_ACCOUNT");
      onboardingLink.value = $store.getters.stripeLoginLink;
    };

    return {
      goBack,
      skip,
      goNext,
      routeName,
      createConnect,
      stripeStatus,
      refresh,
      goToStripe,
      onboardingLink,
      hiddenLinkElement
    };
  },
};
</script>
